import { trigger, animate, style, transition, state } from '@angular/animations';

var testMode: boolean = false;
var animationTime: number = 1000;

if (testMode) {
  animationTime *= 10;
}

// Routable animations
export const fadeInOutAnimation =
  trigger('routeAnimation', [
    transition('* <=> *', [
      style({ opacity: 0 }),
      animate(animationTime + 'ms ease-in-out', style({ opacity: 1 }))
    ]),
  ]);

export const visibleContentAnimation =
  trigger('loadedFadeAnimation', [
    state('visible', style({
      opacity: 1
    })),
    state('hidden', style({
      opacity: 0
    })),
    state('void', style({
      opacity: 0
    })),
    transition('void <=> visible', [
      animate(animationTime + 'ms ease-in-out')
    ]),
  ]);

  export const heightContentAnimation =
  trigger('loadedHeightAnimation', [
    state('visible', style({
      opacity: 1,
      height: '*',
      overflow: 'visible'
    })),
    state('hidden', style({
      opacity: 0,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
      overflow: 'hidden'
    })),
    transition('hidden => visible', [
      animate(animationTime * .75 + 'ms ease-in-out')
    ]),
    transition('visible => hidden', [
      animate(animationTime * .5 + 'ms ease-in-out')
    ]),
    transition('void => visible', [
      style({ opacity: 0, height: 0, overflow: 'hidden' }),
      animate(animationTime * .75 + 'ms ease-in-out')
    ])
  ]);

  export const widthContentAnimation =
  trigger('loadedWidthAnimation', [
    state('visible', style({
      opacity: 1,
      width: '*',
      overflow: 'visible'
    })),
    state('hidden', style({
      opacity: 0,
      width: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
      overflow: 'hidden'
    })),
    transition('hidden => visible', [
      animate(animationTime * .75 + 'ms ease-in-out')
    ]),
    transition('visible => hidden', [
      animate(animationTime * .5 + 'ms ease-in-out')
    ]),
    transition('void => visible', [
      style({ opacity: 0, width: 0, overflow: 'hidden' }),
      animate(animationTime * .75 + 'ms ease-in-out')
    ])
  ]);

export const slideInLeftAnimation =
  trigger('loadedSlideInLeft', [
    transition(':enter', [
      style({ transform: 'translateX(-100%)' }),
      animate('400ms ease-in-out', style({ transform: 'translateX(0)'})),
    ]),
    transition(':leave', [
      style({ transform: 'translateX(0)' }),
      animate('400ms ease-in-out', style({ transform: 'translateX(-100%)' })),
    ])
  ]);

export const slideInRightAnimation =
  trigger('loadedSlideInRight', [
    transition(':enter', [
      style({ transform: 'translateX(+100%)' }),
      animate('400ms ease-in-out', style({ transform: 'translateX(0)'})),
    ]),
    transition(':leave', [
      style({ transform: 'translateX(0)' }),
      animate('400ms ease-in-out', style({ transform: 'translateX(+100%)' })),
    ])
  ]);

  export const overlayHiddenAnimation =
  trigger('loadedOverlayHidden', [
    transition(':enter', [
      style({ opacity: 0, position: 'relative', top: 0, zIndex: 2 }),
      animate('400ms ease-out', style({ opacity: 1, position: 'relative', top: 0, zIndex: 2 })),
    ]),
    transition(':leave', [
      style({ opacity: 1, position: 'absolute', top: 0, zIndex: 1 }),
      animate('400ms ease-in', style({ opacity: 0, position: 'absolute', top: 0, zIndex: 1 })),
    ])
  ]);
